import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import TenantPage from 'components/common/TenantPage';
import { maintenanceService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { MaintenanceColumns } from 'components/common/enhanced/common-headers';
import { Button, ButtonGroup } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseMaintenanceDialog from './CloseMaintenanceDialog';
import { IMaintenance } from 'interfaces';

export const ExpiringMaintenances = () => {
  const translationPrefix = 'pages.maintenance-expiring';

  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const datagridRefresh = useRef(null);

  const initialParams = useMemo(() => {
    const params: Record<string, string> = {};
    const maintenanceType = searchParams.get('maintenance_type');
    const maintenanceTypeIsnull = searchParams.get('maintenance_type__isnull');

    if (maintenanceType) {
      params.maintenance_type = maintenanceType;
    }
    if (maintenanceTypeIsnull) {
      params.maintenance_type__isnull = maintenanceTypeIsnull;
    }

    return Object.keys(params).length > 0 ? params : undefined;
  }, [searchParams]);

  const [open, setOpen] = useState(false);
  const [maintenanceToClose, setMaintenanceToClose] = useState<IMaintenance | null>(null);

  const setOpenDialog = (row: IMaintenance) => {
    setOpen(true);
    setMaintenanceToClose(row);
  };

  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceToClose(null);
  };

  const showValidityExpiry = useMemo(
    () => Boolean(searchParams.get('maintenance_type')),
    [searchParams]
  );

  const columns: GridColDef[] = MaintenanceColumns(
    setOpenDialog,
    false,
    false,
    true,
    undefined,
    showValidityExpiry
  );

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <Link to="without-date" className="no-underline">
                <Button variant="outlined" size="small">
                  {t(`${translationPrefix}.button-without-date`)}
                </Button>
              </Link>
            </ButtonGroup>
          </div>
        }>
        <EnhancedDataGrid
          columns={columns}
          service={maintenanceService}
          getMethod={maintenanceService.getExpiringMaintenances}
          initialParams={initialParams}
          refresh={datagridRefresh}
        />
        <CloseMaintenanceDialog
          closeDialog={setCloseDialog}
          datagridRefresh={datagridRefresh}
          id={maintenanceToClose?.id}
          maintenance={maintenanceToClose}
          open={open}
        />
      </TenantPage>
    </>
  );
};

export default ExpiringMaintenances;
